import React, { useState, useContext, useEffect } from 'react';
import { UserContext } from '../contexts/userContext';
import request from '../../services/Request';
import MaterialTable from 'material-table';
import BackButton from '../items/buttons/BackButton';
import LoadingIcon from '../items/buttons/LoadingIcon';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Grid, Container } from '@material-ui/core';
import { CloudDownload } from '@material-ui/icons';
import { Email } from '@material-ui/icons';
import Swal from 'sweetalert2';
import MachineSelect from '../dashboard/report/MachineSelect';
import { userLimits } from '../dashboard/uitls/userLimits';
import moment from 'moment';
import { localDateRange } from '../../services/method/methods';
import { ExportToCsv } from 'export-to-csv';
import ForwardIcon from '@mui/icons-material/Forward';
import DeleteIcon from '@mui/icons-material/Delete';
import TransactionMoal from './TransactionMoal';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import * as XLSX from 'xlsx';

const getOrderByEmail = `/orders`;
const getAllOrder = `/allOrders/`;
const getGroupsURL = `/groupsAndMachines/`;

Date.prototype.toShortFormat = function () {
  let monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  let day = this.getDate();

  let monthIndex = this.getMonth();
  let monthName = monthNames[monthIndex];

  let year = this.getFullYear();

  return `${day}-${monthName}-${year}`;
};
export default function Order(props) {
  const { userEmail, filterd, setFiltered } = useContext(UserContext);
  //start at first date of this month
  var date = new Date();
  const [startDate, setStartDate] = useState(new Date(date.getFullYear(), date.getMonth(), 1));
  const [endDate, setEndDate] = useState(new Date());
  const [order, setOrder] = useState([]);
  const [machines, setMachines] = useState([]);
  const [machineName, setMachineName] = useState('All Machines');
  const [loading, setLoading] = useState(false);
  const [groups, setGroups] = useState([]);
  const [groupV, setgroupV] = useState([]);
  const [radio, setRadio] = useState('a');
  const user = JSON.parse(localStorage.getItem('user'));
  const thirdParty = user.thirdPartyLink;
  const [showOrder, setShowOrder] = useState(false);
  const [clientName, setClientName] = useState('');
  const [showAddOrder, setShowAddOrder] = useState(false);
  const [newOrder, setNewOrder] = useState({ price: '', time: '', item: null, tax: '' });
  const [items, setItems] = useState([]);
  const [loadingItems, setLoadingItems] = useState(false);

  const [pagination, setPagination] = useState(
    localStorage.getItem('table_view_trans') ? localStorage.getItem('table_view_trans') : 20
  );

  const isDBA = user?.magex;

  useEffect(() => {
    if (showAddOrder && items.length === 0) {
      fetchItems();
    }
  }, [showAddOrder]);

  const fetchItems = async () => {
    setLoadingItems(true);

    request({
      method: 'get',
      url: `/products/` + id + '/plano',
    })
      .then((res1) => {
        setItems(res1.data);
      })
      .catch((err) => {
        console.log('err', err);
      })
      .finally(() => {
        setLoadingItems(false);
      });
  };

  useEffect(() => {
    localStorage.setItem('table_view_trans', pagination);
  }, [pagination]);

  //getting last 2 url para
  // console.log('window.location.href', window.location.href);
  const urlSplit = window.location.href.split('/');
  //get last 1 and last 2 url
  const lastUrl = urlSplit[urlSplit.length - 1];
  const lastUrl2 = urlSplit[urlSplit.length - 2];

  const { id, tableTitle, showAdmin, superAdmin } = userLimits(
    props.match.params.id,
    props.match.params.group,
    'Transactions',
    'view_trans'
  );

  const showTransactionSettings = showAdmin && user?.features?.transaction;

  useEffect(() => {
    let allMachines = [];
    let isCancelled = false;

    async function getGroups() {
      await request({
        method: 'get',
        url: !props.match.params.group && superAdmin ? getGroupsURL : getGroupsURL + userEmail,
      }).then((res) => {
        if (!isCancelled) {
          setGroups(res.data.groups);
          setMachines(res.data.machines);
          setLoading(true);
          allMachines = res.data.machines.map((e) => e._id);
        }
      });
    }

    getGroups();
    console.log('lastUrl2', lastUrl2);
    if (lastUrl2 === 'memberorder') {
      console.log('123123123');
      handleSearch();
    }

    return () => {
      isCancelled = true;
    };
  }, []);

  const handleStartDate = (e) => {
    setStartDate(e);
  };

  const handleEndDate = (e) => {
    setEndDate(e);
  };

  const handleSearch = async (event) => {
    const { startDateString, endDateString } = localDateRange(startDate, endDate);
    if (lastUrl2 === 'memberorder') {
      await request({
        method: 'post',
        url: `/clientUser/orders`,
        data: {
          _id: lastUrl,
          start: startDateString,
          end: endDateString,
        },
      }).then(async (res) => {
        setOrder(res.data);
        setLoading(true);
        if (res.data?.length > 0) {
          setClientName(res.data[0].clientUser?.email);
        }
      });
      return;
    }
    // console.log('startDateString', new Date(startDateString));
    // console.log('endDateString', new Date(endDateString));
    let filteredArray = [];
    setLoading(false);
    let myIDs = 0;
    if (radio == 'a') {
      setFiltered(machines);
      myIDs = machines.map((e) => e._id).join(',');
      setMachineName('All Machines');
      filteredArray = [...machines];
    }
    if (radio == 'g') {
      const myArray = groupV.map((e) => e.machineID);
      var merged = [].concat.apply([], myArray);
      merged = merged.filter((e, i, self) => i === self.findIndex((t) => t._id == e._id));
      // const filteredArray = machines.filter((e, i) => i == merged.findIndex((t)=>(t._id == e._id)));
      machines.forEach((e) => {
        merged.findIndex((t) => {
          if (t._id == e._id) {
            filteredArray.push(e);
          }
        });
      });
      setFiltered(filteredArray);
      myIDs = filteredArray.map((e) => e._id).join(',');
      setMachineName(`Groups: ${groupV.map((e) => e.name).join(', ')} `);
    }
    if (radio == 'm') {
      setFiltered(groupV);
      filteredArray = [...groupV];
      myIDs = groupV.map((e) => e._id).join(',');
      setMachineName(`Machines: ${groupV.map((e) => e.name).join(', ')} `);
    }
    // console.log(myIDs);
    // console.log(startDateString)
    // console.log(endDateString)
    if (myIDs.length > 0) {
      await request({
        method: 'post',
        url:
          !props.match.params.group && superAdmin
            ? getAllOrder + myIDs + '/' + startDateString + '/' + endDateString
            : getOrderByEmail,
        data: {
          start: startDateString,
          end: endDateString,
          ids: myIDs,
          id: id,
        },
      }).then(async (res) => {
        setOrder(res.data);
        setLoading(true);
      });
    } else {
      setLoading(true);
    }
  };
  let columns = [
    {
      title: 'Order ID',
      field: 'id',
    },
    {
      title: 'Order Date',
      field: 'createdAt',
      render: (rowData) => {
        let date = new Date(rowData.createdAt);
        //show keep old trans date
        if (rowData.realTime) {
          date = moment.utc(date).format('lll');
        } else {
          date = moment(date).format('lll');
        }
        return date;
      },
    },
    {
      title: 'Machine ID',
      field: 'machineInfo.name',
      render: (rowData) =>
        rowData?.machineInfo?.name ? `${rowData?.machineInfo?.name}` : rowData?.machineID?.name,
    },
    {
      title: 'Machine Desc',
      field: 'machineInfo.description',
      render: (rowData) =>
        rowData?.machineInfo?.description
          ? `${rowData?.machineInfo?.description}`
          : rowData?.machineID?.description,
    },
    { title: 'Currency', field: 'currency' },
    { title: 'Tax', field: 'tax', render: (rowData) => `${rowData.tax.toFixed(2)}` },
    { title: 'Sale Amount', field: 'total', render: (rowData) => `${rowData.total.toFixed(2)}` },
    {
      title: 'Email Receipt',
      field: 'email',
      render: (rowData) => {
        if (rowData.email) {
          if (rowData.isCheck) {
            return <span style={{ color: 'blue' }}>{rowData.email}</span>;
          } else {
            return `${rowData.email}`;
          }
        } else {
          return null;
        }
      },
    },
    { title: 'Code Used', field: 'otc' },
    { title: 'Payment Type', field: 'payment_type' },
    { title: 'EXID', field: 'custom' },
    {
      title: 'Status',
      field: 'status',
    },
  ];

  if (thirdParty) {
    columns.push({
      title: 'Third Party',
      field: 'isSent',
      render: (rowData) => {
        let result = '';
        if (rowData.isSent && rowData.send_order_third === 'TRUE') {
          result = 'Succeed';
        }
        if (!rowData.isSent && rowData.send_order_third === 'TRUE') {
          result = 'Failed';
        }
        return result;
      },
    });
  }

  if (user?.features?.mobile) {
    columns.push({
      title: 'Member',
      field: 'clientUser.points_used',

      render: (rowData) => {
        if (rowData.clientUser?._id) {
          return (
            <Button
              variant="contained"
              style={{ fontSize: '0.7rem', minHeight: '50px' }}
              onClick={() => {
                let html = '<br/>';
                html +=
                  `<p> Discount: ${
                    rowData.clientUser.points_used ? rowData.clientUser.points_used / 100 : '0'
                  }</p>` +
                  `<p> Username: ${rowData.clientUser.username}</p>` +
                  `<p> Email: ${rowData.clientUser.email}</p>` +
                  `<p> Points Used: ${rowData.clientUser.points_used}</p>` +
                  `<p> Points gained: ${rowData.clientUser.points_gained}</p>` +
                  `<p> Points left: ${rowData.clientUser.points_total}</p>`;
                Swal.fire({
                  html: html,
                  showCloseButton: true,
                  showConfirmButton: false,
                });
              }}
            >
              Show Member Info
            </Button>
          );
        }
        return `None`;
      },
    });
  }

  const resentTransaction = async (rowData) => {
    // console.log(rowData);
    const sales = [];

    rowData.products.forEach((element, i) => {
      const pd = {
        type: rowData.payment_type ? rowData.payment_type : 'CREDIT',
        price: element.soldPrice + element.tax_amount,
        quantity: element.quantity,
        item: element.port,
        transid: rowData.id + i,
      };
      sales.push(pd);
    });

    const newObject = {
      batchid: rowData.id,
      posid: user.groupCode.toUpperCase() + rowData.machineInfo.name,
      batchtimestamp: rowData.realTime,
      batchservertimestamp: rowData.createdAt,
      sales: sales,
    };

    await request({
      method: 'post',
      url: 'orders/sendThirdParty',
      data: {
        order: newObject,
        thirdParty: thirdParty,
      },
    })
      .then((res) => {
        Swal.fire({
          title: 'Success',
          text: 'Successfully resent the transaction',
          icon: 'success',
        });
      })
      .catch((res) => {
        let text = '';
        console.log('errorduring resend', res.response);
        res.response?.data?.salesfailures?.forEach((element, i) => {
          text += i + 1 + 'sale failed by: ' + element.reason + '\n';
        });
        if (text) {
          Swal.fire({
            title: 'Error',
            text: text,
            icon: 'error',
          });
        } else {
          Swal.fire({
            title: 'Error',
            text: JSON.stringify(res.response),
            icon: 'error',
          });
        }
      });
    // console.log('newObject', newObject);
  };

  const createRandomTransactions = async () => {
    if (groupV?.length !== 1) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Please select exactly one machine before creating random transactions',
      });
      return;
    }

    if (items.length === 0) {
      await fetchItems();
    }

    if (items.length === 0) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No products available for this machine',
      });
      return;
    }

    const machineID = groupV[0]._id;
    const machineName = groupV[0].name;
    
    const transactions = [];

    for (let i = 0; i < 10; i++) {
      const randomItem = items[Math.floor(Math.random() * items.length)];
      const randomPrice = (Math.random() * 50 + 5).toFixed(2);
      const randomTax = (parseFloat(randomPrice) * 0.1).toFixed(2);
      const randomQuantity = Math.floor(Math.random() * 3) + 1;
      
      // Generate random date between startDate and endDate
      const timeDiff = endDate.getTime() - startDate.getTime();
      const randomTime = Math.random() * timeDiff;
      const randomDate = new Date(startDate.getTime() + randomTime);
      
      const randomHour = Math.floor(Math.random() * 24);
      const randomMinute = Math.floor(Math.random() * 60);
      const randomSecond = Math.floor(Math.random() * 60);
      
      const transactionDate = new Date(randomDate);
      transactionDate.setHours(randomHour, randomMinute, randomSecond);
      
      const realTime = new Date(transactionDate);
      const offset = transactionDate.getTimezoneOffset();
      transactionDate.setTime(transactionDate.getTime() - offset * 60 * 1000);

      const transactionData = {
        createdAt: transactionDate,
        realTime: realTime,
        referTo: user?.referTo,
        machineID: machineID,
        total: parseFloat(randomPrice) + parseFloat(randomTax),
        tax: parseFloat(randomTax),
        status: 'Completed',
        payment_type: 'CREDIT',
        lang: 'manual created',
        id: (machineName + transactionDate.getTime() + i).slice(0, -1),
        products: [
          {
            quantity: randomQuantity,
            status: 'SUCCESS',
            product: randomItem._id,
            tax_amount: parseFloat(randomTax),
            soldPrice: parseFloat(randomPrice),
            discount: 0,
          },
        ],
        createdBy: user.email,
        note: 'random transaction created',
      };
      
      transactions.push(transactionData);
    }

    try {
      Swal.fire({
        title: 'Creating Transactions...',
        text: 'Please wait while we create 10 random transactions',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      for (const transaction of transactions) {
        await request({
          method: 'post',
          url: '/orders/create',
          data: transaction,
        });
      }

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: '10 random transactions created successfully',
      });

      handleSearch();
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'Failed to create random transactions',
      });
    }
  };

  useEffect(() => {
    console.log('order', order);
  }, [order]);

  return (
    <div>
      {!loading && <LoadingIcon />}
      <div style={{ maxWidth: '100%' }}>
        <Container maxWidth="xl" style={{ marginTop: '5px', marginBottom: '5px', padding: '20px' }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <MachineSelect
                disableselection={lastUrl2 === 'memberorder' ? true : false}
                filterd={filterd}
                handleStartDate={handleStartDate}
                handleEndDate={handleEndDate}
                startDate={startDate}
                endDate={endDate}
                setRadio={setRadio}
                setgroupV={setgroupV}
                radio={radio}
                groupV={groupV}
                groups={groups}
                machines={machines}
                handleChange={handleSearch}
              />
            </Grid>
          </Grid>
        </Container>
        {/* </Box> */}
        <MaterialTable
          onChangeRowsPerPage={setPagination}
          columns={columns}
          data={order}
          title={lastUrl2 === 'memberorder' ? `Member Orders(${clientName})` : 'Orders'}
          detailPanel={(rowData) => {
            // console.log(rowData);
            return (
              <TableContainer component={Paper} style={{ backgroundColor: '#EBEBE8' }}>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Product Name</TableCell>
                      <TableCell>UPC/SKU</TableCell>
                      <TableCell align="right">Discount</TableCell>
                      <TableCell align="right">Promotion Used</TableCell>
                      <TableCell align="right">Code Sent</TableCell>
                      <TableCell align="right">Quantity</TableCell>
                      <TableCell align="right">Cost Price(unit)</TableCell>
                      <TableCell align="right">Cost Price(total)</TableCell>
                      <TableCell align="right">Unit Price</TableCell>
                      <TableCell align="right">Sub Total without Tax</TableCell>
                      <TableCell align="right">Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rowData.products.map(
                      (prod, i) =>
                        prod.productInfo && (
                          <TableRow key={i} style={prod.err ? { backgroundColor: '#fea7a5' } : {}}>
                            <TableCell component="th" scope="row">
                              {prod.productInfo.name}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {prod.productInfo.upc}
                            </TableCell>
                            <TableCell align="right">{'' + prod.discount.toFixed(2)}</TableCell>
                            {prod.promoType ? (
                              <TableCell align="right">
                                {prod.codeEntered} ({prod.promoType})
                              </TableCell>
                            ) : prod.promoInfo ? (
                              <TableCell align="right">
                                {prod.promoInfo.title} ({prod.promoInfo.promoType})
                              </TableCell>
                            ) : (
                              <TableCell align="right">No Promotion</TableCell>
                            )}
                            {prod.code ? (
                              <TableCell align="right">{prod.code}</TableCell>
                            ) : (
                              <TableCell align="right">No Code</TableCell>
                            )}
                            <TableCell align="right">{prod.quantity}</TableCell>
                            <TableCell align="right">{prod.productInfo?.costPrice}</TableCell>
                            <TableCell align="right">
                              {(prod.productInfo?.costPrice * prod.quantity).toFixed(2)}
                            </TableCell>
                            <TableCell align="right">
                              {(prod.soldPrice / prod.quantity).toFixed(2)}
                            </TableCell>
                            <TableCell align="right">{prod.soldPrice.toFixed(2)}</TableCell>
                            <TableCell align="right">
                              {prod.refund_details?.status || prod.status}
                            </TableCell>
                          </TableRow>
                        )
                    )}
                    {rowData.products?.length > 0 &&
                      rowData.products[0].bundle_details?.length > 0 &&
                      rowData.products[0].bundle_details.map((prod, i) => (
                        <TableRow key={i} style={prod.err ? { backgroundColor: '#fea7a5' } : {}}>
                          <TableCell component="th" scope="row">
                            {prod.name + ' (Bundle Item)'}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {prod.upc}
                          </TableCell>
                          <TableCell align="right">{''}</TableCell>
                          <TableCell align="right">{``}</TableCell>
                          <TableCell align="right">{``}</TableCell>
                          <TableCell align="right">{1}</TableCell>
                          <TableCell align="right">{``}</TableCell>
                          <TableCell align="right">{``}</TableCell>
                          <TableCell align="right">{prod.soldPrice.toFixed(2)}</TableCell>
                          <TableCell align="right">{prod.soldPrice.toFixed(2)}</TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            );
          }}
          onRowClick={(event, rowData, togglePanel) => togglePanel()}
          options={{
            actionsColumnIndex: -1,
            pageSize: parseInt(pagination),
            pageSizeOptions: [10, 20, 50, 100, 200],
          }}
          actions={[
            {
              tooltip: 'Download CSV(Per Trans)',
              isFreeAction: true,
              icon: CloudDownload,
              onClick: (evt, d) => {
                let length = 0;
                console.log(order);

                const filteredArray = [...order].filter((e) => e.products.some((e) => !e.err));

                const outPutArray = filteredArray.map((e) => {
                  if (e.products.length > length) length = e.products.length;
                  let date = new Date(e.createdAt);
                  let date1 = new Date(e.createdAt);
                  if (e.realTime) {
                    date = moment.utc(date).format('lll');
                    date1 = moment.utc(date).format('MM/DD/YYYY');
                  } else {
                    date = moment(date).format('lll');
                    date1 = moment(date).format('MM/DD/YYYY');
                  }
                  date = date.replaceAll(',', ' ');
                  if (!e.machineInfo?.name) {
                    e.machineInfo = e.machineID;
                  }
                  //replace description too, because it may contain comma
                  if (e.machineInfo.description) {
                    e.machineInfo.description = e.machineInfo.description.replaceAll(',', ';');
                  }
                  return {
                    Order_ID: e.id,
                    Order_Date: date,
                    Order_Date_Only: date1,
                    Machine_ID: e.machineInfo.name,
                    Machine_Desc: e.machineInfo.description,
                    currency: e.currency,
                    Tax: e.tax,
                    Sale_Amount: e.total,
                    Products: e.products,
                    Email: e.email,
                    One_Time_Code: e.otc,
                    Subscripted: e.isCheck,
                    payment_type: e.payment_type,
                    EXID: e.custom,
                  };
                });
                let csv = 'data:text/csv;charset=utf-8,';

                let header = `Order_ID,Order_Date,Order_Date_Only,Machine_ID,Machine_Desc,Currency,Tax,Sale_Amount,Email,Email_Subscribed,Code_Used,Payment_Type,`;

                for (var i = 1; i <= length; i++) {
                  header += `Product${i} Name,Product${i} UPC/SKU,Product${i} Cost Price(unit),Product${i} Cost Price(total),Product${i} Unit Price, Product${i} Quantity,Product${i} Sub Total without Tax,Product${i} Tax,Product${i} Promotion Used,Product${i} Code Sent,Product${i} Discount, `;
                }

                let values = outPutArray
                  .map((o) => {
                    let r = '';
                    r +=
                      o.Order_ID +
                      ',' +
                      o.Order_Date +
                      ',' +
                      o.Order_Date_Only +
                      ',' +
                      o.Machine_ID +
                      ',' +
                      o.Machine_Desc +
                      ',' +
                      o.currency +
                      ',' +
                      o.Tax +
                      ',' +
                      o.Sale_Amount +
                      ',';
                    if (o.Email) r += o.Email + ',';
                    else r += ' ,';
                    if (o.Subscripted) r += o.Subscripted + ',';
                    else r += ' ,';

                    if (o.One_Time_Code) r += o.One_Time_Code + ',';
                    else r += ' ,';

                    if (o.payment_type) r += o.payment_type + ',';
                    else r += ' ,';

                    o.Products.forEach((element, idx) => {
                      if (!element.err) {
                        let i = idx + 1;
                        if (element.productInfo) {
                          const name = element.productInfo?.name?.replaceAll(',', ';');

                          r += name + ',';

                          r += element.productInfo.upc + ',';
                          r += element.productInfo.costPrice + ',';
                          r += element.quantity + ',';
                          r += element.productInfo.price + ',';
                        } else {
                          r += ' ,';
                          r += ' ,';
                          r += ' ,';
                          r += ' ,';
                        }

                        r += element.quantity + ',' + element.soldPrice + ',';
                        if (element.tax_amount) {
                          r += element.tax_amount + ',';
                        } else {
                          r += 0 + ',';
                        }
                        if (element.promoInfo)
                          r +=
                            element.promoInfo.title + '(' + element.promoInfo.promoType + ')' + ',';
                        else r += ' ,';
                        if (element.code) r += element.code + ',';
                        else r += ' ,';
                        r += element.discount + ' ,';
                      }
                    });
                    return r;
                  })
                  .join('\n');
                csv += header + '\n' + values;
                var encodedUri = encodeURI(csv);
                var link = document.createElement('a');
                link.setAttribute('href', encodedUri);
                link.setAttribute('download', 'my_transaction_data.csv');
                document.body.appendChild(link); // Required for FFo

                link.click();
              },
            },
            {
              tooltip: 'Download CSV(Per Item)',
              isFreeAction: true,
              icon: CloudDownload,
              onClick: (evt, data) => {
                console.log('id', id);
                //for MSC
                if (id === 'adrian.pittaway@msccruises.com') {
                  let EUROPA = ['5320', '5321', '5322', '5323', '5324', '5327'];
                  let EURIBIA = ['5508', '5509', '5510', '5511', '5512', '5513', '5491'];

                  let productArray = [];
                  order.forEach((transaction) => {
                    transaction?.products?.forEach((product) => {
                      if (EUROPA.includes(transaction?.machineInfo?.name)) {
                        transaction.group = 'EUROPA';
                      } else if (EURIBIA.includes(transaction?.machineInfo?.name)) {
                        transaction.group = 'EURIBIA';
                      }
                      let obj = {
                        Date: moment(new Date(transaction.createdAt))
                          .utc()
                          .format('YYYY/MM/DD HH:mm'),
                        'Machine ID': transaction?.machineInfo?.name,
                        'Machine Desc': transaction?.machineInfo?.description,
                        Group: transaction.group,
                        UPC: product?.productInfo?.upc,
                        Product: product?.productInfo?.name,
                        Price: parseFloat(product?.soldPrice.toFixed(2)),
                        TYPE: transaction?.account_type || '',
                      };
                      productArray.push(obj);
                    });
                  });

                  productArray.sort((a, b) => {
                    return new Date(a.Date) - new Date(b.Date);
                  });
                  // Create a new workbook and add the data
                  const wb = XLSX.utils.book_new();
                  const ws = XLSX.utils.json_to_sheet(productArray);

                  // Add the worksheet to the workbook
                  XLSX.utils.book_append_sheet(wb, ws, 'MSC Transactions');

                  const filename = `MSC_Report_${moment().format('YYYYMMDD')}.xlsx`;
                  // Generate and trigger a download of the file
                  XLSX.writeFile(wb, filename);
                  return;
                }

                const filteredArray = [...order];
                let length = 0;
                let outPutArray = [];
                filteredArray.forEach((e) => {
                  let date = new Date(e.createdAt);
                  let date1 = new Date(e.createdAt);
                  if (e.realTime) {
                    date = moment.utc(date).format('lll');
                    date1 = moment.utc(date).format('MM/DD/YYYY');
                  } else {
                    date = moment(date).format('lll');
                    date1 = moment(date).format('MM/DD/YYYY');
                  }
                  if (!e.machineInfo?.name) {
                    e.machineInfo = e.machineID;
                  }
                  date = date.replace(',', ' ');
                  for (var i = 0; i < e.products?.length; i++) {
                    const thisData = {
                      Order_ID: e.id,
                      Order_Date: date,
                      Order_Date_Only: date1,
                      Machine_ID: e.machineInfo.name,
                      Machine_Desc: e.machineInfo.description,
                      Currency: e.currency,
                      Sale_Amount:
                        e.products[i].soldPrice +
                        (e.products[i].tax_amount ? e.products[i].tax_amount : 0),
                      Tax: e.products[i].tax_amount ? e.products[i].tax_amount : 0,
                      Email: e.email ? e.email : '',
                      Email_Subscribed: e.isCheck ? e.isCheck : '',
                      Code_Used: e.otc ? e.otc : '',
                      Payment_Type: e.payment_type ? e.payment_type : '',
                      EXID: e.custom ? e.custom : '',
                      Product_Name: e.products[i].productInfo?.name,
                      Product_UPC_SKU: e.products[i].productInfo?.upc,
                      Product_Cost_Price: e.products[i].productInfo?.costPrice,
                      Product_Unit_Price: e.products[i].productInfo?.price,
                      Product_Quantity: e.products[i].quantity,

                      Product_Promotion: e.products[i].promoInfo
                        ? e.products[i].promoInfo?.title +
                          '(' +
                          e.products[i].promoInfo?.promoType +
                          ')'
                        : '',
                      Product_Code_Sent: e.products[i].code ? e.products[i].code : '',
                      Product_Discount: e.products[i].discount,
                    };

                    if (!e.products[i].err) {
                      outPutArray.push(thisData);
                    }
                  }
                });

                const options = {
                  fieldSeparator: ',',
                  quoteStrings: '"',
                  decimalSeparator: '.',
                  useTextFile: false,
                  filename: 'Sales Report CSV(per item)',
                  useKeysAsHeaders: true,
                };

                const csvExporter = new ExportToCsv(options);
                csvExporter.generateCsv(outPutArray);
              },
            },
            {
              tooltip: 'Send Email Receipt',
              icon: Email,
              onClick: async (event, rowData) => {
                const { value: email } = await Swal.fire({
                  title: 'Enter the email address',
                  input: 'text',
                  inputPlaceholder: 'Enter the email ("delete" for deleting email address)',
                });
                if (email) {
                  Swal.fire({
                    title: `Please Wait for response`,
                    didOpen: () => {
                      Swal.showLoading();
                    },
                  });

                  await request({
                    method: 'post',
                    url: '/receipt/manual',
                    data: {
                      email: email,
                      orderID: rowData.id,
                    },
                  })
                    .then(() => {
                      Swal.fire({
                        icon: 'success',
                        text: `The receipt has been send.`,
                      });
                    })
                    .catch((err) => {
                      Swal.fire({
                        icon: 'error',
                        text: err?.response?.data,
                      });
                    });
                }
              },
            },
            thirdParty && {
              tooltip: 'Resend transaction to third party',
              icon: ForwardIcon,
              onClick: async (evt, data) => {
                if (!data.isSent && data.send_order_third === 'TRUE') {
                  resentTransaction(data);
                } else {
                  if (data.send_order_third === 'FALSE') {
                    Swal.fire({
                      icon: 'error',
                      text: `This transaction has been disabled to send to third party`,
                    });
                  } else {
                    Swal.fire({
                      icon: 'error',
                      text: `This transaction has been sent to third party`,
                    });
                  }
                }
              },
            },
            isDBA && {
              tooltip: 'Delete Order',
              icon: DeleteIcon,
              onClick: async (evt, rowData) => {
                if (rowData.lang !== 'manual created') {
                  Swal.fire({
                    icon: 'error',
                    title: 'Cannot Delete',
                    text: 'Only manually created orders can be deleted',
                  });
                  return;
                }
                const result = await Swal.fire({
                  title: 'Are you sure?',
                  text: `You are about to delete order ${rowData.id}`,
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  confirmButtonText: 'Yes, delete it!',
                });

                if (result.isConfirmed) {
                  try {
                    await request({
                      method: 'delete',
                      url: `/orders/delete/${rowData._id}`,
                    });

                    Swal.fire({
                      icon: 'success',
                      title: 'Deleted!',
                      text: 'Order has been deleted successfully',
                    });

                    handleSearch();
                  } catch (error) {
                    Swal.fire({
                      icon: 'error',
                      title: 'Error',
                      text: error.response?.data?.message || 'Failed to delete order',
                    });
                  }
                }
              },
            },
            // {
            //   tooltip: 'Send to my email',
            //   isFreeAction: true,
            //   icon: Email,
            //   onClick: async (evt, data) => {
            //     //redundent code
            //     let length = 0;
            //     const outPutArray = order.map((e) => {
            //       if (e.products.length > length) length = e.products.length;
            //       let date = new Date(e.createdAt);
            //       if (e.realTime) {
            //         date = moment.utc(date).format('lll');
            //       } else {
            //         date = moment(date).format('lll');
            //       }
            //       date = date.replace(',', ' ');

            //       return {
            //         Order_ID: e._id,
            //         Order_Date: date,
            //         Machine_ID: e.machineInfo.name,
            //         Machine_Desc: e.machineInfo.description,
            //         currency: e.currency,
            //         Tax: e.tax,
            //         Sale_Amount: e.total,
            //         Products: e.products,
            //       };
            //     });
            //     let csv = '';
            //     let header = `Order_ID,Order_Date,Machine_ID,Machine_Desc,currency,Tax,Sale_Amount,`;
            //     for (var i = 1; i <= length; i++) {
            //       header += `Product${i} Name,Product${i} Cost Price(unit),Product${i} Cost Price(total),Product${i} Unit Price, Product${i} Quantity,Product${i} Sub Total without Tax,Product${i} Promotion Used,Product${i} Discount, `;
            //     }

            //     let values = outPutArray
            //       .map((o) => {
            //         let r = '';
            //         r +=
            //           o.Order_ID +
            //           ',' +
            //           o.Order_Date +
            //           ',' +
            //           o.Machine_ID +
            //           ',' +
            //           o.Machine_Desc +
            //           ',' +
            //           o.currency +
            //           ',' +
            //           o.Tax +
            //           ',' +
            //           o.Sale_Amount +
            //           ',';
            //         o.Products.forEach((element, idx) => {
            //           let i = idx + 1;
            //           if (element.product) {
            //             r += element.product.name?.en + ',';
            //             r += element.product.costPrice + ',';
            //             r += element.quantity + ',';
            //             r += element.product.price + ',';
            //           } else {
            //             r += ' ,';
            //             r += ' ,';
            //             r += ' ,';
            //             r += ' ,';
            //           }

            //           r += element.quantity + ',' + element.soldPrice + ',';
            //           if (element.promo)
            //             r += element.promo.code + '(' + element.promo.promoType + ')' + ',';
            //           else r += ' ,';
            //           r += element.discount + ' ,';
            //         });
            //         return r;
            //       })
            //       .join('\n');
            //     csv += header + '\n' + values;

            //     const { value: email } = await Swal.fire({
            //       title: 'Enter your email address',
            //       input: 'email',
            //       inputPlaceholder: 'Enter your email address',
            //     });
            //     if (email) {
            //       await request({
            //         method: 'post',
            //         url: '/email/sendcsv',
            //         data: {
            //           email: email,
            //           csv: csv,
            //         },
            //       }).then((res) => {
            //         Swal.fire(`The table has been send to your email as csv file.`);
            //       });
            //     }
            //   },
            // },
          ]}
        />
        <BackButton />
        {showTransactionSettings && (
          <Button
            style={{ marginTop: '50px' }}
            variant="contained"
            color="primary"
            onClick={() => setShowOrder(true)}
          >
            Transaction Settings
          </Button>
        )}
        {isDBA && (
          <Button
            style={{ marginTop: '50px', marginLeft: '10px' }}
            variant="contained"
            color="secondary"
            onClick={() => setShowAddOrder(true)}
          >
            Add New Order
          </Button>
        )}
        {isDBA && (
          <Button
            style={{ marginTop: '50px', marginLeft: '10px' }}
            variant="contained"
            color="primary"
            onClick={() => createRandomTransactions()}
          >
            Create 10 Random Transactions
          </Button>
        )}
      </div>
      <TransactionMoal
        setLoading={setLoading}
        machines={machines}
        setMachines={setMachines}
        user={user}
        show={showOrder}
        onHide={() => setShowOrder(false)}
      />
      <Dialog open={showAddOrder} onClose={() => setShowAddOrder(false)} maxWidth="md" fullWidth>
        <DialogTitle>Add New Order</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} style={{ marginTop: '10px' }}>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Time"
                type="datetime-local"
                value={newOrder.time}
                onChange={(e) => setNewOrder({ ...newOrder, time: e.target.value })}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Price Without Tax"
                type="number"
                value={newOrder.price}
                onChange={(e) => setNewOrder({ ...newOrder, price: e.target.value })}
                variant="outlined"
                inputProps={{ step: '0.01' }}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Tax"
                type="number"
                value={newOrder.tax}
                onChange={(e) => setNewOrder({ ...newOrder, tax: e.target.value })}
                variant="outlined"
                inputProps={{ step: '0.01' }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Autocomplete
                options={items}
                getOptionLabel={(option) =>
                  `${option.upc || ''} - ${option.name?.en || option.name || ''}`
                }
                value={newOrder.item}
                onChange={(event, newValue) => {
                  setNewOrder({ ...newOrder, item: newValue });
                }}
                disabled={loadingItems}
                loading={loadingItems}
                filterOptions={(options, { inputValue }) => {
                  const filtered = options.filter((option) => {
                    const name = option.name?.en || option.name || '';
                    const upc = option.upc || '';
                    return (
                      name.toLowerCase().includes(inputValue.toLowerCase()) ||
                      upc.toLowerCase().includes(inputValue.toLowerCase())
                    );
                  });
                  return filtered;
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Item"
                    variant="outlined"
                    placeholder={loadingItems ? 'Loading items...' : 'Search by UPC or name...'}
                  />
                )}
                renderOption={(option) => (
                  <div>
                    <strong>{option.upc || 'N/A'}</strong>
                    <br />
                    <small>{option.name?.en || option.name || ''}</small>
                  </div>
                )}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowAddOrder(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick={async () => {
              if (
                !newOrder.price ||
                !newOrder.time ||
                !newOrder.item ||
                !newOrder.tax ||
                groupV?.length !== 1
              ) {
                Swal.fire({
                  icon: 'error',
                  title: 'Error',
                  text: 'Please fill in all fields',
                });
                return;
              }
              const machineID = groupV[0]._id;
              const machineName = groupV[0].name;
              let date = new Date();
              let realTime = new Date();
              const offset = date.getTimezoneOffset();
              date.setTime(date.getTime() - offset * 60 * 1000);

              const data = {
                createdAt: date,
                realTime: realTime,
                referTo: user?.referTo,
                machineID: machineID,
                total: parseFloat(newOrder.price) + parseFloat(newOrder.tax),
                tax: parseFloat(newOrder.tax),
                status: 'Completed',
                payment_type: '',
                lang: 'manual created',
                id: (machineName + new Date(date).getTime()).slice(0, -1),
                products: [
                  {
                    quantity: 1,
                    status: 'SUCCESS',
                    product: newOrder.item._id,
                    tax_amount: parseFloat(newOrder.tax),
                    soldPrice: parseFloat(newOrder.price),
                    discount: 0,
                  },
                ],
                createdBy: user.email,
                note: 'manual created',
              };

              try {
                await request({
                  method: 'post',
                  url: '/orders/create',
                  data: data,
                });

                Swal.fire({
                  icon: 'success',
                  title: 'Success',
                  text: 'Order created successfully',
                });

                setNewOrder({ price: '', time: '', item: null, tax: '' });
                setShowAddOrder(false);
                handleSearch();
              } catch (error) {
                Swal.fire({
                  icon: 'error',
                  title: 'Error',
                  text: error.response?.data?.message || 'Failed to create order',
                });
              }
            }}
            color="primary"
            variant="contained"
          >
            Create Order
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
